import { COLLECT_REPORT } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: COLLECT_REPORT,
  okAction: 'importCollectTemplate',
  callBackAction: '',
  formatData(data) {
    data.projectId = data.templateDownload
    delete data.templateDownload
    delete data.uploadDesc
    return data
  },
  view: {
    labelWidth: '260px',
    width: '625px',
    title: '批量导入客户环境采集信息（按模板）',
    content: [
      {
        $id: 'templateDownload',
        $type: 'sky-collect-template-link'
      },
      {
        $id: 'fileName',
        $type: 'upload-file',
        label: '客户环境信息采集模板数据',
        rules: [
          { notEmpty: { message: '客户环境信息采集模板数据不能为空' } },
          'longLength',
          { fileSize: { min: 1 } },
          {
            suffix: {
              includeSuffixes: ['xlsx'],
              errorMessage: '请选择Excel文档格式的文件进行上传'
            }
          }
        ],
        props: {
          ellipsisMessage: true
        }
      },
      {
        $id: 'uploadDesc',
        $type: 'sky-alert-description',
        $el: {
          label: '请先下载导入模板并按格式填写后，再进行上传',
          hasList: true,
          type: 'warning'
        }
      }
    ]
  }
}
